import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ContractService } from 'src/app/services/contract.service';

@Component({
    selector: 'app-contract-form',
    templateUrl: './contract-form.component.html',
    styleUrls: ['./contract-form.component.scss']
})
export class ContractFormComponent implements OnInit {

    @Input() contractId: number;
    contractForm: FormGroup;
    soldNotes: any[] = [];

    validationEmpty = [];
    validationIncorrect = [];

    constructor(private formBuilder: FormBuilder,
        private contractService: ContractService,
        private alertService: HttpAlertService,
        private translate: TranslateService
    ) {
        this.contractForm = this.formBuilder.group({
            contract_id: [0, Validators.required],
            contract_bill_number: ['', Validators.required],
            arranger_name: ['', Validators.required],
            arranger_surname: ['', Validators.required],
            arranger_street: ['', Validators.required],
            arranger_street_number: ['', Validators.required],
            arranger_city: ['', Validators.required],
            arranger_postal_code: ['', Validators.required],
            arranger_pesel: ['', Validators.required],
            arranger_bank_name: ['', Validators.required],
            arranger_bank_account_number: ['', Validators.required],
            contract_payment_gross: ['', Validators.required],
            contract_payment_net: ['', Validators.required],
            contract_payment_cost_of_getting_income: ['', Validators.required],
            contract_payment_base_to_tax: ['', Validators.required],
            contract_payment_income_tax: ['', Validators.required],
            contract_payment_income_tax_to_pay: ['', Validators.required],
            contract_taxes_cost_of_geting_income: ['', Validators.required],
            contract_taxes_income_tax: ['', Validators.required],
            contract_sold_notes: [[], Validators.required],
            company_name_mianownik: ['', Validators.required],
            company_street: ['', Validators.required],
            company_street_number: ['', Validators.required],
            company_postal_code: ['', Validators.required],
            company_city_mianownik: ['', Validators.required],
            company_nip: ['', Validators.required],
            contract_date: ['', Validators.required],
            contract_bill_date: ['', Validators.required],
            arranger_id: ['', Validators.required],
        });
    }

    private convertUnitToSubunit(value: number): number {
        return Math.round(value) / 100;
    }

    private convertSubunitToUnit(value: number): number {
        return Math.round(value * 100);
    }

    ngOnInit() {
        setTimeout(() => {
            this.contractService.editContract(this.contractId).subscribe((response: any) => {
                if ("OK" == response.message) {
                    let d: any = response.data.data;
                    this.validationEmpty = response.data.error_data.empty;
                    this.validationIncorrect = response.data.error_data.incorrect;
                    this.contractForm.controls['contract_id'].setValue(d.contract_id);
                    this.contractForm.controls['contract_bill_number'].setValue(d.contract_bill_number);
                    this.contractForm.controls['arranger_name'].setValue(d.arranger_name);
                    this.contractForm.controls['arranger_surname'].setValue(d.arranger_surname);
                    this.contractForm.controls['arranger_street'].setValue(d.arranger_street);
                    this.contractForm.controls['arranger_street_number'].setValue(d.arranger_street_number);
                    this.contractForm.controls['arranger_city'].setValue(d.arranger_city);
                    this.contractForm.controls['arranger_postal_code'].setValue(d.arranger_postal_code);
                    this.contractForm.controls['arranger_pesel'].setValue(d.arranger_pesel);
                    this.contractForm.controls['arranger_bank_name'].setValue(d.arranger_bank_name);
                    this.contractForm.controls['arranger_bank_account_number'].setValue(d.arranger_bank_account_number);
                    this.contractForm.controls['contract_payment_gross'].setValue(this.convertUnitToSubunit(d.contract_payment_gross));
                    this.contractForm.controls['contract_payment_net'].setValue(this.convertUnitToSubunit(d.contract_payment_net));
                    this.contractForm.controls['contract_payment_cost_of_getting_income'].setValue(this.convertUnitToSubunit(d.contract_payment_cost_of_getting_income));
                    this.contractForm.controls['contract_payment_base_to_tax'].setValue(this.convertUnitToSubunit(d.contract_payment_base_to_tax));
                    this.contractForm.controls['contract_payment_income_tax'].setValue(this.convertUnitToSubunit(d.contract_payment_income_tax));
                    this.contractForm.controls['contract_payment_income_tax_to_pay'].setValue(this.convertUnitToSubunit(d.contract_payment_income_tax_to_pay));
                    this.contractForm.controls['contract_taxes_cost_of_geting_income'].setValue(d.contract_taxes_cost_of_geting_income);
                    this.contractForm.controls['contract_taxes_income_tax'].setValue(d.contract_taxes_income_tax);
                    this.contractForm.controls['contract_sold_notes'].setValue(d.contract_sold_notes);
                    this.contractForm.controls['company_name_mianownik'].setValue(d.company_name_mianownik);
                    this.contractForm.controls['company_street'].setValue(d.company_street);
                    this.contractForm.controls['company_street_number'].setValue(d.company_street_number);
                    this.contractForm.controls['company_postal_code'].setValue(d.company_postal_code);
                    this.contractForm.controls['company_city_mianownik'].setValue(d.company_city_mianownik);
                    this.contractForm.controls['company_nip'].setValue(d.company_nip);
                    this.contractForm.controls['contract_date'].setValue(d.contract_date);
                    this.contractForm.controls['contract_bill_date'].setValue(d.contract_bill_date);
                    this.contractForm.controls['arranger_id'].setValue(d.arranger_id);
                    
                    this.contractForm.controls['contract_id'].disable();

                    this.convertTaxesValues();
                    this.roundNumbers();

                    for (let i = 0; i < d.contract_sold_notes.length; i++) {
                        this.soldNotes.push({
                            title: d.contract_sold_notes[i].title,
                            total: d.contract_sold_notes[i].total,
                            price: this.convertUnitToSubunit(d.contract_sold_notes[i].price),
                            title_empty: false,
                            title_incorrect: false,
                            total_empty: false,
                            total_incorrect: false,
                            price_empty: false,
                            price_incorrect: false
                        });
                    }

                }
            });
        });
    }

    @Output() finishEditing: EventEmitter<any> = new EventEmitter();
    public onFinishEditing() {
        this.finishEditing.emit(this.contractId);
    }

    private getDate(date: Date): string {
        if(typeof date == 'string'){
            return date;
        }
       
        let year = String(date.getFullYear());
        let month = date.getMonth() + 1 < 10 ? '0' + String(date.getMonth() + 1) : String(date.getMonth() + 1);
        let day = date.getDate() < 10 ? '0' + String(date.getDate()) : String(date.getDate());
        return year + '-' + month + '-' + day;
    }

    public onSubmit() {
        this.roundNumbers();
        if (!this.validateNotesList()) {
            this.alertService.error(this.translate.instant('contract_form_validation_error_1'));
            return false;
        }
        const searchRegExp2 = new RegExp(',', 'g');
        try {
            this.contractForm.controls['contract_taxes_cost_of_geting_income'].setValue(
                this.contractForm.controls['contract_taxes_cost_of_geting_income'].value * 100
            );
            this.contractForm.controls['contract_taxes_income_tax'].setValue(
                this.contractForm.controls['contract_taxes_income_tax'].value * 100
            );
        } catch (error) {
            console.error(error);
        }
        // przywrócenie id
        this.contractForm.controls['contract_id'].setValue(this.contractId);

        // zmiana przecinków na kropki
        this.contractForm.controls['contract_payment_income_tax_to_pay'].setValue(
            String(this.contractForm.controls['contract_payment_income_tax_to_pay'].value).replace(searchRegExp2, '.')
        );

        // data
        this.contractForm.controls['contract_bill_date'].setValue(this.getDate(this.contractForm.controls['contract_bill_date'].value));
        this.contractForm.controls['contract_date'].setValue(this.getDate(this.contractForm.controls['contract_date'].value));

        this.contractForm.controls['contract_payment_income_tax'].setValue(
            String(this.contractForm.controls['contract_payment_income_tax'].value).replace(searchRegExp2, '.')
        );
        this.contractForm.controls['contract_payment_base_to_tax'].setValue(
            String(this.contractForm.controls['contract_payment_base_to_tax'].value).replace(searchRegExp2, '.')
        );
        this.contractForm.controls['contract_payment_cost_of_getting_income'].setValue(
            String(this.contractForm.controls['contract_payment_cost_of_getting_income'].value).replace(searchRegExp2, '.')
        );
        this.contractForm.controls['contract_payment_net'].setValue(
            String(this.contractForm.controls['contract_payment_net'].value).replace(searchRegExp2, '.')
        );
        this.contractForm.controls['contract_payment_gross'].setValue(
            String(this.contractForm.controls['contract_payment_gross'].value).replace(searchRegExp2, '.')
        );

        // przypisanie nut
        this.recalculateContractValues();
        this.contractForm.controls['contract_sold_notes'].setValue(this.soldNotes);
        this.contractForm.controls['contract_id'].enable();
        this.contractService.submitEditedContract(this.contractForm.value).subscribe(response => {
            if ('CONTRACT_DOES_NOT_EXISTS' == response.data.status) {
                this.alertService.error(this.translate.instant('contract_form_validation_error_3'));
            } else if ('INCORRECT_DATA' == response.data.status) {
                this.alertService.error(this.translate.instant('contract_form_validation_error_1'));
                this.validationEmpty = response.data.error_data.empty;
                this.validationIncorrect = response.data.error_data.incorrect;
                this.convertTaxesValues();
                this.roundNumbers();
                this.contractForm.controls['contract_id'].disable();
            } else if ('CONTRACT_UPDATED' == response.data.status) {
                this.alertService.success(this.translate.instant('contract_form_validation_success_1'));
                this.onFinishEditing();
            } else {
                this.alertService.error(this.translate.instant('contract_form_validation_error_2'));
            }
        });

    }

    private recalculateContractValues(): void {
        this.soldNotes.forEach((value) => {
            value.price = this.convertSubunitToUnit(value.price);
        });
        this.contractForm.controls['contract_payment_gross'].setValue(this.convertSubunitToUnit(this.contractForm.controls['contract_payment_gross'].value));
        this.contractForm.controls['contract_payment_net'].setValue(this.convertSubunitToUnit(this.contractForm.controls['contract_payment_net'].value));
        this.contractForm.controls['contract_payment_cost_of_getting_income'].setValue(this.convertSubunitToUnit(this.contractForm.controls['contract_payment_cost_of_getting_income'].value));
        this.contractForm.controls['contract_payment_base_to_tax'].setValue(this.convertSubunitToUnit(this.contractForm.controls['contract_payment_base_to_tax'].value));
        this.contractForm.controls['contract_payment_income_tax'].setValue(this.convertSubunitToUnit(this.contractForm.controls['contract_payment_income_tax'].value));
        this.contractForm.controls['contract_payment_income_tax_to_pay'].setValue(this.convertSubunitToUnit(this.contractForm.controls['contract_payment_income_tax_to_pay'].value));
    }

    private roundNumbers() {
        this.contractForm.controls['contract_payment_income_tax_to_pay'].setValue(
            Math.round(Number(this.contractForm.controls['contract_payment_income_tax_to_pay'].value) * 100) / 100
        );
        this.contractForm.controls['contract_payment_income_tax'].setValue(
            Math.round(Number(this.contractForm.controls['contract_payment_income_tax'].value) * 100) / 100
        );
        this.contractForm.controls['contract_payment_base_to_tax'].setValue(
            Math.round(Number(this.contractForm.controls['contract_payment_base_to_tax'].value) * 100) / 100
        );
        this.contractForm.controls['contract_payment_cost_of_getting_income'].setValue(
            Math.round(Number(this.contractForm.controls['contract_payment_cost_of_getting_income'].value) * 100) / 100
        );
        this.contractForm.controls['contract_payment_net'].setValue(
            Math.round(Number(this.contractForm.controls['contract_payment_net'].value) * 100) / 100
        );
        this.contractForm.controls['contract_payment_gross'].setValue(
            Math.round(Number(this.contractForm.controls['contract_payment_gross'].value) * 100) / 100
        );
    }

    private convertTaxesValues() {
        this.contractForm.controls['contract_taxes_cost_of_geting_income'].setValue(
            this.contractForm.controls['contract_taxes_cost_of_geting_income'].value * 100
        );
        this.contractForm.controls['contract_taxes_income_tax'].setValue(
            this.contractForm.controls['contract_taxes_income_tax'].value * 100
        );
    }

    private validateNotesList(): boolean {
        let isOK: boolean = true;
        for (let i = 0; i < this.soldNotes.length; i++) {

            if (this.soldNotes[i].total < 1 || isNaN(this.soldNotes[i].total)) {
                this.soldNotes[i].total_incorrect = true; isOK = false;
            } else if (this.soldNotes[i].total == null) {
                this.soldNotes[i].total_empty = true; isOK = false;
            }

            if (this.soldNotes[i].price < 1 || isNaN(this.soldNotes[i].price)) {
                this.soldNotes[i].price_incorrect = true; isOK = false;
            } else if (this.soldNotes[i].price == null) {
                this.soldNotes[i].price_empty = true; isOK = false;
            }

            if (!this.soldNotes[i].title.length || this.soldNotes[i].title == '') {
                this.soldNotes[i].title_empty = true; isOK = false;
            }
        }

        return isOK;
    }

    public onDeleteNoteFromList(index: number): void {
        if (this.soldNotes[index] != null) {
            this.soldNotes.splice(index, 1);
        }
    }

    public onAddNewSoldNote(): void {
        this.soldNotes.push({ id: '', title: '', total: 0, title_empty: false, title_incorrect: false, total_empty: false, total_incorrect: false });
    }

    public onNoteTitleResetValidation(index: number): void {
        if (this.soldNotes[index] != null) {
            this.soldNotes[index].title_empty = false;
            this.soldNotes[index].title_incorrect = false;
        }
    }

    public onNoteTotalResetValidation(index: number): void {
        if (this.soldNotes[index] != null) {
            this.soldNotes[index].total_empty = false;
            this.soldNotes[index].total_incorrect = false;
        }
    }

    public onNotePriceResetValidation(index: number): void {
        if (this.soldNotes[index] != null) {
            this.soldNotes[index].price_empty = false;
            this.soldNotes[index].price_incorrect = false;
        }
    }

    public hasError(table: string, error: string): boolean {
        if ('EMPTY' == table) {
            for (let i = 0; i < this.validationEmpty.length; i++) {
                if (this.validationEmpty[i] == error) {
                    return true;
                }
            }
        } else if ('INCORRECT' == table) {
            for (let i = 0; i < this.validationIncorrect.length; i++) {
                if (this.validationIncorrect[i] == error) {
                    return true;
                }
            }
        }

        return false;
    }

}